<template>
    <div class="submain">
        <h1>{{hTitle}}</h1>
        <div class="content">
            <!-- 详情 -->
            <div class="xqbox" v-if="contentId == 1">
                <div class="flexbox cell">
                    <span>问题编号：</span>
                    <div class="rightcon">{{ problemDetail.TP_CODE }}</div>
                </div>
                <div class="flexbox cell">
                    <span>客户简称：</span>
                    <div class="rightcon">{{ problemDetail.TP_CUSTOMER }}</div>
                </div>
                <div class="flexbox cell">
                    <span>联系人：</span>
                    <div class="rightcon">{{ problemDetail.TP_LINKMAN }}</div>
                </div>
                <div class="flexbox cell">
                    <span>联系方式：</span>
                    <div class="rightcon">{{ problemDetail.TP_PHONE }}</div>
                </div>
                <div class="flexbox cell">
                    <span>业务员：</span>
                    <div class="rightcon">{{ problemDetail.BUSINESSUSER }}</div>
                </div>                
                <!-- <div class="flexbox cell">
                    <span>问题大类：</span>
                    <div class="rightcon">{{ problemDetail.BPROBLEM }}</div>
                </div>
                <div class="flexbox cell">
                    <span>问题小类：</span>
                    <div class="rightcon">{{ problemDetail.LPROBLEM }}</div>
                </div> -->
                <div class="flexbox cell areabox" style="align-items: center;">
                    <span>主题：</span>
                    <div class="rightcon">{{ problemDetail.TP_THEME }}</div>
                </div>
                <div v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>项目地址：</span>
                    <div class="rightcon">{{ problemDetail.TP_INFO }}</div>
                </div>
                <div v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>项目对接人：</span>
                    <div class="rightcon">{{ problemDetail.TP_COUNTERPART }}</div>
                </div>
                <div v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>项目联系方式：</span>
                    <div class="rightcon">{{ problemDetail.TP_INFORMATION }}</div>
                </div>
                <div  v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>铭牌号：</span>
                    <div class="rightcon">{{ problemDetail.TP_NAMEPLATENO }}</div>
                </div>               
                <div class="" v-for="(item, index) in problemConnect" :key="index">
                    <div class="" v-if="item.TYPE == 'BC'">
                        <div class="cell gtbox">
                            <div class="flexbox celltop">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <span class="grayw">申请人</span>
                                <span>{{ item.LUUSERNAME }}</span>
                                <!-- <span>{{ item.CTTIME }}</span> -->
                            </div>
                            <div class="cellcon">
                                <p>问题描述：</p>
                                <p class="grayw">{{ item.REMAKE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>问题描述附件：</span>
                            <div class="flexbox rightcon">                                
                                <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                    <img class="fjimg" :src="it.PICSUB">
                                    <p class="fjname">{{it.GPOLDNAME}}</p>
                                </a>
                                <!-- <img class="fjimg" :src="it.url" v-for="it in item.picarr"> -->
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>申请时间：</span>
                            <div class="rightcon">{{ item.CTTIME }}</div>
                        </div>
                    </div>
                    <div class="" v-if="item.TYPE == 'GT'">
                        <div class="cell gtbox">
                            <div class="flexbox celltop">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <span class="grayw">主责人</span>
                                <span>{{ item.LUUSERNAME }}</span>
                                <!-- <span>{{ item.CTTIME }}</span> -->
                            </div>
                            <div class="cellcon">
                                <p>沟通描述：</p>
                                <p class="grayw">{{ item.REMAKE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>沟通描述附件：</span>
                            <div class="flexbox rightcon">
                                <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                    <img class="fjimg" :src="it.PICSUB">
                                    <p class="fjname">{{it.GPOLDNAME}}</p>
                                </a>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>处理时间：</span>
                            <div class="rightcon">{{ item.CTTIME }}</div>
                        </div>
                    </div>
                </div>
                <div class="" v-for="(item, index) in problemReply" :key="index">
                    <div class="cellan">
                        <div class="flexbox">
                            <div class="left flexbox">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <p>{{ item.STEP }}</p>
                                <p>{{ item.REPLYUSER }}</p>
                            </div>
                            <div class="right"></div>
                        </div>
                        <div class="repplycon">
                            <p v-if="item.PROTYPE != 'CL'">{{ item.PROTYPE == 'PJ' ? '评价描述：' : '审批内容：' }}</p>
                            <p v-else>问题解答：</p>
                            <p class="grayw">{{ item.REMAKE }}</p>
                        </div>
                    </div>
                    <div class="flexbox cell">
                        <span v-if="item.PROTYPE != 'CL'">{{ item.PROTYPE == 'PJ' ? '评价时间：' : '审批时间：' }}</span>
                        <span v-else>实际完成时间：</span>
                        <div class="rightcon">{{ item.REPLYTIME }}</div>
                    </div>
                    <div v-if="item.TPE_REPLY_QUALITY != ''" class="flexbox cell">
                        <span>回复质量评价：</span>
                        <div class="rightcon">
                            <el-rate
                                v-model="item.TPE_REPLY_QUALITY"
                                show-text
                                disabled
                                :texts='rateText'
                            />
                        </div>
                    </div>
                    <div v-if="item.TPE_REPLY_MANNER != ''" class="flexbox cell">
                        <span>回复人员态度评价：</span>
                        <div class="rightcon">
                            <el-rate
                                v-model="item.TPE_REPLY_MANNER"
                                show-text
                                disabled
                                :texts='rateText'
                            />
                        </div>    
                    </div>
                    <div v-if="item.TPE_REPLY_EFF != ''" class="flexbox cell">
                        <span>回复效率评价：</span>
                        <div class="rightcon">
                            <el-rate
                                v-model="item.TPE_REPLY_EFF"
                                show-text
                                disabled
                                :texts='rateText'
                            />
                        </div>
                    </div>
                    <div v-if="item.PROTYPE != 'SP'" class="flexbox cell">
                        <span>{{ item.PROTYPE =='PJ' ? '评价描述附件：' : '问题解答附件：' }}</span>
                        <div class="flexbox rightcon">
                            <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                <img class="fjimg" :src="it.PICSUB">
                                <p class="fjname">{{it.GPOLDNAME}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- <div v-if="problemDetail.PJREMAKE != ''" class="flexbox cell">
                    <span>评价描述：</span>
                    <div class="rightcon">{{ problemDetail.PJREMAKE }}</div>
                </div>
                <div v-if="problemDetail.QUALITY != ''" class="flexbox cell">
                    <span>回复质量评价：</span>
                    <div class="rightcon">
                        <el-rate
                            v-model="problemDetail.QUALITY"
                            show-text
                            disabled
                            :texts='rateText'
                        />
                    </div>
                </div>
                <div v-if="problemDetail.MANNER != ''" class="flexbox cell">
                    <span>回复人员态度评价：</span>
                    <div class="rightcon">
                        <el-rate
                            v-model="problemDetail.MANNER"
                            show-text
                            disabled
                            :texts='rateText'
                        />
                    </div>    
                </div>
                <div v-if="problemDetail.EFF != ''" class="flexbox cell">
                    <span>回复效率评价：</span>
                    <div class="rightcon">
                        <el-rate
                            v-model="problemDetail.EFF"
                            show-text
                            disabled
                            :texts='rateText'
                        />
                    </div>
                </div>
                <div v-if="problemDetail.PJREMAKE != ''" class="flexbox cell">
                    <span>问题评价附件：</span>
                    <div class="flexbox rightcon">
                        <a v-for="it in pjpicarr" :href="it.url" target="_blank">
                            <img class="fjimg" :src="it.url">
                            <p class="fjname">{{it.GPOLDNAME}}</p>
                        </a>
                    </div>
                </div> -->
                <div v-if="problemDetail.TP_EVALUATE_SUPPLY != ''" class="flexbox cell">
                    <span>补充评价：</span>
                    <div class="rightcon">{{ problemDetail.TP_EVALUATE_SUPPLY }}</div>
                </div>
                <div v-if="problemDetail.TP_EVALUATE_SUPPLY != ''" class="flexbox cell">
                    <span>补充评价附件：</span>
                    <div class="flexbox rightcon">
                        <a v-for="it in pjpicarrbc" :href="it.url" target="_blank">
                            <img class="fjimg" :src="it.url">
                            <p class="fjname">{{it.GPOLDNAME}}</p>
                        </a>
                    </div>
                </div>
            </div>
            <!-- 补充信息 -->
            <div class="xqbox" v-if="contentId == 2">
                <div class="flexbox cell">
                    <span>问题编号：</span>
                    <div class="rightcon">{{ problemDetail.TP_CODE }}</div>
                </div>
                <div class="flexbox cell">
                    <span>客户简称：</span>
                    <div class="rightcon">{{ problemDetail.TP_CUSTOMER }}</div>
                </div>
                <div class="flexbox cell">
                    <span>联系人：</span>
                    <div class="rightcon">{{ problemDetail.TP_LINKMAN }}</div>
                </div>
                <div class="flexbox cell">
                    <span>联系方式：</span>
                    <div class="rightcon">{{ problemDetail.TP_PHONE }}</div>
                </div>
                <div class="flexbox cell areabox" style="align-items: center;">
                    <span>主题：</span>
                    <div class="rightcon">{{ problemDetail.TP_THEME }}</div>
                </div>
                <div class="" v-for="(item, index) in problemConnect" :key="index">
                    <div class="" v-if="item.TYPE == 'BC'">
                        <div class="cell gtbox">
                            <div class="flexbox celltop">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <span class="grayw">申请人</span>
                                <span>{{ item.LUUSERNAME }}</span>
                                <!-- <span>{{ item.CTTIME }}</span> -->
                            </div>
                            <div class="cellcon">
                                <p>问题描述：</p>
                                <p class="grayw">{{ item.REMAKE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>问题描述附件：</span>
                            <div class="flexbox rightcon">
                                <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                    <img class="fjimg" :src="it.PICSUB">
                                    <p class="fjname">{{it.GPOLDNAME}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="" v-if="item.TYPE == 'GT'">
                        <div class="cell gtbox">
                            <div class="flexbox celltop">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <span class="grayw">主责人</span>
                                <span>{{ item.LUUSERNAME }}</span>
                                <!-- <span>{{ item.CTTIME }}</span> -->
                            </div>
                            <div class="cellcon">
                                <p>沟通描述：</p>
                                <p class="grayw">{{ item.REMAKE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>沟通描述附件：</span>
                            <div class="flexbox rightcon">
                                <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                    <img class="fjimg" :src="it.PICSUB">
                                    <p class="fjname">{{it.GPOLDNAME}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="" v-for="(item, index) in problemReply" :key="index">
                    <div class="cellan">
                        <div class="flexbox">
                            <div class="left flexbox">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <p>{{ item.STEP }}</p>
                                <p>{{ item.REPLYUSER }}</p>
                            </div>
                            <div class="right"></div>
                        </div>
                        <div class="repplycon">
                            <p v-if="item.STEP =='申请人' || item.STEP =='审批人'">{{ item.STEP =='申请人'? '评价描述：' : '审批内容：' }}</p>
                            <p v-else>问题解答：</p>
                            <p class="grayw">{{ item.REMAKE }}</p>
                        </div>
                    </div>
                    <div class="flexbox cell">
                        <span>问题解答附件：</span>
                        <div class="flexbox rightcon">
                            <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                <img class="fjimg" :src="it.PICSUB">
                                <p class="fjname">{{it.GPOLDNAME}}</p>
                            </a>
                        </div>
                    </div>
                </div> -->
                <div class="flexbox cell">
                    <span>补充问题描述：</span>
                    <div class="rightcon">
                        <el-input
                        type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="supplyContent.supplyText">
                        </el-input>
                    </div>
                </div>
                <div class="flexbox cell" v-if="ishasgroupId">
                    <span>上传补充附件：</span>
                    <div class="rightcon">
                        <UpLoad :fileList="fileList" :groupId="hasgroupId" @groupIdSend="groupIdRec"></UpLoad>
                        <p class="grayw">支持格式.rar .zip .doc .docx .pdf .jpg .png .xlsx，单个文件不能超过200MB</p>
                    </div>
                </div>
            </div>
            <!-- 客户评价 -->
            <div class="xqbox" v-if="contentId == 3">
                <div class="redw cell">
                    备注：请在收到回复7天内进行评价。
                </div>
                <div class="flexbox cell">
                    <span>问题编号：</span>
                    <div class="rightcon">{{ problemDetail.TP_CODE }}</div>
                </div>
                <div class="flexbox cell">
                    <span>客户简称：</span>
                    <div class="rightcon">{{ problemDetail.TP_CUSTOMER }}</div>
                </div>
                <div class="flexbox cell">
                    <span>联系人：</span>
                    <div class="rightcon">{{ problemDetail.TP_LINKMAN }}</div>
                </div>
                <div class="flexbox cell">
                    <span>联系方式：</span>
                    <div class="rightcon">{{ problemDetail.TP_PHONE }}</div>
                </div>
                <div class="flexbox cell">
                    <span>业务员：</span>
                    <div class="rightcon">{{ problemDetail.BUSINESSUSER }}</div>
                </div>
                <div class="flexbox cell areabox" style="align-items: center;">
                    <span>主题：</span>
                    <div class="rightcon">{{ problemDetail.TP_THEME }}</div>
                </div>
                <div   v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>项目地址：</span>
                    <div class="rightcon">{{ problemDetail.TP_INFO }}</div>
                </div>
                <div  v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>项目对接人：</span>
                    <div class="rightcon">{{ problemDetail.TP_COUNTERPART }}</div>
                </div>
                <div  v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>项目联系方式：</span>
                    <div class="rightcon">{{ problemDetail.TP_INFORMATION }}</div>
                </div>
                <div  v-if="problemMsg.qtype =='TS'" class="flexbox cell">
                    <span>铭牌号：</span>
                    <div class="rightcon">{{ problemDetail.TP_NAMEPLATENO }}</div>
                </div> 
                <div class="" v-for="(item, index) in problemConnect" :key="index">
                    <div class="" v-if="item.TYPE == 'BC'">
                        <div class="cell gtbox">
                            <div class="flexbox celltop">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <span class="grayw">申请人</span>
                                <span>{{ item.LUUSERNAME }}</span>
                                <!-- <span>{{ item.CTTIME }}</span> -->
                            </div>
                            <div class="cellcon">
                                <p>问题描述：</p>
                                <p class="grayw">{{ item.REMAKE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>申请时间：</span>
                            <div class="rightcon">{{ item.CTTIME }}</div>
                        </div>
                        <div class="flexbox cell">
                            <span>问题描述附件：</span>
                            <div class="flexbox rightcon">
                                <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                    <img class="fjimg" :src="it.PICSUB">
                                    <p class="fjname">{{it.GPOLDNAME}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="" v-if="item.TYPE == 'GT'">
                        <div class="cell gtbox">
                            <div class="flexbox celltop">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <span class="grayw">主责人</span>
                                <span>{{ item.LUUSERNAME }}</span>
                                <!-- <span>{{ item.CTTIME }}</span> -->
                            </div>
                            <div class="cellcon">
                                <p>沟通描述：</p>
                                <p class="grayw">{{ item.REMAKE }}</p>
                            </div>
                        </div>
                        <div class="flexbox cell">
                            <span>处理时间：</span>
                            <div class="rightcon">{{ item.CTTIME }}</div>
                        </div>
                        <div class="flexbox cell">
                            <span>沟通描述附件：</span>
                            <div class="flexbox rightcon">
                                <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                    <img class="fjimg" :src="it.PICSUB">
                                    <p class="fjname">{{it.GPOLDNAME}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="" v-for="(item, index) in problemLastReply" :key="index">
                    <div class="cellan">
                        <div class="flexbox">
                            <div class="left flexbox">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <p>{{ item.STEP }}</p>
                                <p>{{ item.REPLYUSER }}</p>
                            </div>
                            <div class="right"></div>
                        </div>
                        <div class="repplycon">
                            <p>问题解答：</p>
                            <p class="grayw">{{ item.REMAKE }}</p>
                        </div>
                    </div>
                    <div class="flexbox cell">
                        <span>实际完成时间：</span>
                        <div class="rightcon">{{ item.REPLYTIME }}</div>
                    </div>
                    <div class="flexbox cell">
                        <span>问题解答附件：</span>
                        <div class="flexbox rightcon">
                            <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                <img class="fjimg" :src="it.PICSUB">
                                <p class="fjname">{{it.GPOLDNAME}}</p>
                            </a>
                        </div>
                    </div>
                </div>
                <!-- <div class="" v-for="(item, index) in problemReply" :key="index">
                    <div class="cellan">
                        <div class="flexbox">
                            <div class="left flexbox">
                                <el-avatar icon="el-icon-user-solid" size="small"></el-avatar>
                                <p>{{ item.STEP }}</p>
                                <p>{{ item.REPLYUSER }}</p>
                            </div>
                            <div class="right"></div>
                        </div>
                        <div class="repplycon">
                            <p v-if="item.STEP =='申请人' || item.STEP =='审批人'">{{ item.STEP =='申请人'? '评价描述：' : '审批内容：' }}</p>
                            <p v-else>问题解答：</p>
                            <p class="grayw">{{ item.REMAKE }}</p>
                        </div>
                    </div>
                    <div class="flexbox cell">
                        <span v-if="item.STEP =='申请人' || item.STEP =='审批人'">{{ item.STEP =='申请人'? '评价时间：' : '审批时间：' }}</span>
                        <span>实际完成时间：</span>
                        <div class="rightcon">{{ item.REPLYTIME }}</div>
                    </div>
                    <div v-if="item.TPE_REPLY_QUALITY != ''" class="flexbox cell">
                        <span>回复质量评价：</span>
                        <div class="rightcon">
                            <el-rate
                                v-model="item.TPE_REPLY_QUALITY"
                                show-text
                                disabled
                                :texts='rateText'
                            />
                        </div>
                    </div>
                    <div v-if="item.MANNER != ''" class="flexbox cell">
                        <span>回复人员态度评价：</span>
                        <div class="rightcon">
                            <el-rate
                                v-model="item.MANNER"
                                show-text
                                disabled
                                :texts='rateText'
                            />
                        </div>    
                    </div>
                    <div v-if="item.EFF != ''" class="flexbox cell">
                        <span>回复效率评价：</span>
                        <div class="rightcon">
                            <el-rate
                                v-model="item.EFF"
                                show-text
                                disabled
                                :texts='rateText'
                            />
                        </div>
                    </div>
                    <div v-if="item.STEP !='审批人'" class="flexbox cell">
                        <span>{{ item.STEP =='申请人'? '评价描述附件：' : '问题解答附件：' }}</span>
                        <div class="flexbox rightcon">
                            <a v-for="it in item.SPFT" :href="it.PICSUB" target="_blank">
                                <img class="fjimg" :src="it.PICSUB">
                                <p class="fjname">{{it.GPOLDNAME}}</p>
                            </a>
                        </div>
                    </div>
                </div> -->
                <div class="flexbox cell">
                    <span>回复质量评价：</span>
                    <div class="rightcon">
                        <el-rate
                        v-model="evaluateContent.equality"
                        show-text
                        :texts='rateText'
                        @change="rateChange">
                        </el-rate>
                    </div>
                </div>
                <div class="flexbox cell">
                    <span>回复人员态度评价：</span>
                    <div class="rightcon">
                        <el-rate
                        v-model="evaluateContent.emanner"
                        show-text
                        :texts='rateText'
                        @change="rateChange">
                        </el-rate>
                    </div>    
                </div>
                <div class="flexbox cell">
                    <span>回复效率评价：</span>
                    <div class="rightcon">
                        <el-rate
                        v-model="evaluateContent.eeff"
                        show-text
                        :texts='rateText'
                        @change="rateChange">
                        </el-rate>
                    </div>
                </div>
                <div class="flexbox cell">
                    <span>其他建议：</span>
                    <div class="rightcon">
                        <el-input
                        type="textarea"
                        placeholder="请输入内容"
                        v-model="evaluateContent.evaluateText"
                        maxlength="1000"
                        :autosize="{ minRows: 3, maxRows: 5}"
                        show-word-limit
                        >
                        </el-input>
                    </div>
                </div>
                <div class="flexbox cell">
                    <span>问题评价附件：</span>
                    <div class="rightcon">
                        <UpLoad :fileList="fileListb" :groupId="hasgroupIdb" @groupIdSend="groupIdRecb"></UpLoad>
                        <p class="grayw">支持格式.rar .zip .doc .docx .pdf .jpg .png .xlsx，单个文件不能超过200MB</p>
                    </div>
                </div>
            </div>
            <div class="btns">
                <el-button type="primary" v-if="zcShow" @click="submitPro('save')">暂存</el-button>
                <el-button type="primary" plain v-if="tjShow" @click="submitPro('submit')">提交</el-button>
                <el-button plain @click="pageBack">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { ref, reactive, toRefs, getCurrentInstance, onBeforeMount } from 'vue'
    import { useRouter } from 'vue-router'
    import { ElMessage } from 'element-plus'
    import UpLoad from '@/components/upload/UpLoad'

    export default {
        name: 'ProblemHandling',
        components: {
            UpLoad
        },
        setup() {
            let router = useRouter()
            let { proxy } = getCurrentInstance()
            let btnsShow = reactive({
                zcShow: true,
                tjShow: true
            })
            let hTitle = ref('')
            let contentId = ref(1)
            let pageData = reactive({
                quType: '',
                problemMsg: '',
                problemDetail: {
                    QUALITY: 0,
                    MANNER: 0,
                    EFF: 0,
                },
                pjpicarr: [], // 评价附件
                pjpicarrbc: [], // 补充评价附件
                rateText: ['不满意', '不满意', '满意', '非常满意', '非常满意'],
                problemReply: [],
                problemConnect: [],
                problemLastReply: [],
                // 补充信息
                supplyContent: {
                    supplyText: '',
                    tprId: '',
                    annex: ''
                },
                // 评价
                evaluateContent: {
                    equality: 0,
                    emanner: 0,
                    eeff: 0,
                    evaluateText: '',
                    annex: ''
                },
            })
            // 问题详情
            let getProblemDetail = () => {
                let data = {
                    postType: 'load',
                    type: pageData.problemMsg.qtype,
                    cztype: 'XQ',	
                    problemCode: pageData.problemMsg.tp_code,
                }
                proxy.$axios.postReq('/meide/REST/ProblemClose', data)
                .then(res => {
                    if(res.success == 'true') {
                        res.items[0].QUALITY = res.items[0].QUALITY != '' ? parseFloat(res.items[0].QUALITY) : ''
                        res.items[0].MANNER = res.items[0].MANNER != '' ? parseFloat(res.items[0].MANNER) : ''
                        res.items[0].EFF = res.items[0].EFF != '' ? parseFloat(res.items[0].EFF) : ''
                        pageData.evaluateContent.annex = res.items[0].RJPIC? res.items[0].RJPIC: ''
                        if(res.items[0].RJPIC != '') {
                            getEnclosure(res.items[0].RJPIC, '', 'pjpicarr')
                        }
                        if(res.items[0].TP_BCPIC != '') {
                            getEnclosure(res.items[0].TP_BCPIC, '', 'pjpicarrbc')
                        }
                        pageData.problemDetail = res.items[0]
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            let rateChange = () => {
                proxy.$forceUpdate()
            }
            // 答复列表
            let getReply = () => {
                let data = {
                    postType: 'loadReply',
                    type: pageData.problemMsg.qtype,
                    source: 'user',	
                    problemCode: pageData.problemMsg.tp_code,	
                }
                proxy.$axios.postReq('/meide/REST/ProblemClose', data)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.problemReply = res.items.data
                        // console.log(res.items.data[0].SPFT)

                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 最后答复列表
            let getLastReply = () => {
                let data = {
                    postType: 'loadLastReply',
                    type: pageData.problemMsg.qtype,
                    source: 'customer',	
                    problemCode: pageData.problemMsg.tp_code,	
                }
                proxy.$axios.postReq('/meide/REST/ProblemClose', data)
                .then(res => {
                    if(res.success == 'true') {
                        pageData.problemLastReply = res.items.data
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 沟通信息历史
            let getConnect = () => {
                let data = {
                    postType: 'loadConnect',
                    // postType: 'loadReply',
                    type: pageData.problemMsg.qtype,
                    problemCode: pageData.problemMsg.tp_code,
                }
                proxy.$axios.postReq('/meide/REST/ProblemClose', data)
                .then(res => {
                    if(res.success == 'true') {
                        let len = res.items.data.length - 1
                        if(res.items.data[len].TYPE == 'BC' && pageData.problemMsg.handle != 'detail') {
                            pageData.supplyContent.supplyText = res.items.data[len].REMAKE
                            pageData.supplyContent.tprId = res.items.data[len].TPR_ID
                            hasgroupId.value = res.items.data[len].PIC // 附件
                            pageData.supplyContent.annex = res.items.data[len].PIC
                            // 读取附件
                            getEnclosure(res.items.data[len].PIC, '', 'canedit')
                            
                            pageData.problemConnect = res.items.data.slice(0, len)
                        }else {
                            pageData.problemConnect = res.items.data
                        }
                        ishasgroupId.value = true
                    }else {
                        proxy.$alert(res.ErrorText, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    }
                }).catch(error => {
                    // proxy.$alert(error, '提示', {
                    //     confirmButtonText: '确定',
                    //     callback: action => {}
                    // });
                })
            }
            // 读取附件
            let getEnclosure = (gid, annexarr, type) => {
                let data = {
                    postType: 'loadPic',
                    GID: gid
                }
                if(gid != '') {
                    proxy.$axios.postReq('/meide/REST/ProblemClose', data)
                    .then(res => {
                        if(res.success == 'true') {
                            let arr = []
                            res.items.map(item => {
                                let obj = {
                                    name: item. GPFILENAME,
                                    url: item.FILENAME,
                                    // url:'444',
                                    FID: item. GPFILENAME,
                                    GPOLDNAME: item.GPOLDNAME
                                }
                                arr.push(obj)
                            })
                            if(type == 'canedit') {
                                fileList.value = arr
                            }else if(type == 'pjpicarr') {
                                pageData.pjpicarr = arr
                            }else if(type == 'pjpicarrbc') {
                                pageData.pjpicarrbc = arr
                            }else {
                                annexarr = arr
                            }
                        }else {
                            proxy.$alert(res.ErrorText, '提示', {
                                confirmButtonText: '确定',
                                callback: action => {}
                            });
                        }
                    }).catch(error => {
                        proxy.$alert(error, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {}
                        });
                    })
                }
            }
            // 提交附加内容(补充信息 & 评价)
            let submitPClick = ref(true)
            let submitPro = (handle) => {
                if(submitPClick.value) {
                    submitPClick.value = false
                    let data = {}
                    if(pageData.problemMsg.handle == 'supply') {
                        data = {
                            postType: 'addInfor',		
                            type: pageData.problemMsg.qtype, // 问题类型 咨询：ZX 投诉 TS	
                            problemCode: pageData.problemMsg.tp_code, // 问题编码	
                            problemDescr: pageData.supplyContent.supplyText,// 补充描述
                            tprId: pageData.supplyContent.tprId,
                            pic: pageData.supplyContent.annex, // 补充附件	
                            operate: handle, // save:暂存  submit:提交	
                        }
                    }else if(pageData.problemMsg.handle == 'evaluate') {
                        data = {
                            postType: 'Cusreviews',		
                            type: pageData.problemMsg.qtype, // 问题类型 咨询：ZX 投诉 TS	
                            problemCode: pageData.problemMsg.tp_code, // 问题编码
                            reply_quality: (pageData.evaluateContent.equality).toString(), // 回复质量	
                            reply_manner: (pageData.evaluateContent.emanner).toString(), // 回复人员态度	
                            reply_eff: (pageData.evaluateContent.eeff).toString(), // 回复效率	
                            remake: pageData.evaluateContent.evaluateText, // 备注	
                            repic: pageData.evaluateContent.annex, // 图片
                        }
                    }
                    
                    proxy.$axios.postReq('/meide/REST/ProblemCloseSub', data)
                    .then(res => {
                        if(res.success == 'true') {
                            ElMessage.success({
                                message: res.Info,
                                type: 'success'
                            });
                            setTimeout(() => {
                                router.push({
                                    name: 'MyQuestion'
                                })
                            }, 500)
                            submitPClick.value = true
                        }else {
                            proxy.$alert(res.ErrorText, '提示', {
                                confirmButtonText: '确定',
                                callback: action => {
                                    submitPClick.value = true
                                }
                            });
                        }
                    }).catch(error => {
                        proxy.$alert(error, '提示', {
                            confirmButtonText: '确定',
                            callback: action => {
                                submitPClick.value = true
                            }
                        });
                    })
                }
                
            }
            // 返回
            let pageBack = () => {
                router.push({
                    name: 'MyQuestion',
                    params: {
                        wtType: pageData.problemMsg.qtype
                    }
                })
            }
            // 沟通的附件上传
            let fileList = ref([])
            let hasgroupId = ref('') // 返回来的gid
            let ishasgroupId = ref(false) // 有没有返回来
            let groupIdRec = (gid) => {
                pageData.supplyContent.annex = gid
            }
            // 评价的附件上传
            let fileListb = ref([])
            let hasgroupIdb = ref('') // 返回来的gid
            let groupIdRecb = (gid) => {
                pageData.evaluateContent.annex = gid
            }

            onBeforeMount(() => {
                pageData.problemMsg = router.currentRoute.value.query
                if(pageData.problemMsg.handle == 'detail') {
                    btnsShow.zcShow = false
                    btnsShow.tjShow = false
                    hTitle.value = '问题详情'
                    contentId.value = 1
                }else if(pageData.problemMsg.handle == 'supply') {
                    hTitle.value = '补充信息'
                    contentId.value = 2
                }else if(pageData.problemMsg.handle == 'evaluate') {
                    btnsShow.zcShow = false
                    hTitle.value = '客户评价'
                    contentId.value = 3
                    getLastReply()
                }
                getProblemDetail()
                getReply()
                getConnect()
            })

            return {
                ...toRefs(pageData),
                ...toRefs(btnsShow),
                hTitle,
                contentId,
                getProblemDetail,
                rateChange,
                getReply,
                getConnect,
                getLastReply,
                getEnclosure,
                groupIdRec,
                submitPClick,
                submitPro,
                pageBack,
                fileList,
                hasgroupId,
                ishasgroupId,
                groupIdRecb,
                fileListb,
                hasgroupIdb,
            }
        }
    }
</script>

<style scoped lang="scss">
    .submain {
        padding: 10px;
        background: #fff;
        h1 {
            font-size: 16px;
            padding: 10px 0;
            border-bottom: 1px solid rgba(223, 223, 223, 1);
        }
        .content {
            padding: 10px 40px;
            a {
                display: block;
                margin-right: 10px;
            }
            .xqbox {
                .redw {
                    padding-left: 80px;
                }
                .cell {
                    margin: 20px 0;
                    span {
                        display: block;
                        width: 150px;
                        text-align: right;
                        margin-right: 15px;
                        color: #969696;
                    }
                    .rightcon {
                        min-width: 460px;
                    }
                }
                .areabox {
                    align-items: flex-start;
                    .rightcon {
                        padding: 10px;
                        background: rgba(248, 248, 248, 1);
                        border: 1px solid rgba(215, 215, 215, 1);
                    }
                }
                .cellan {
                    margin-left: 150px;
                    padding: 10px;
                    border: 1px solid rgba(215, 215, 215, 1);
                    width: 550px;
                    justify-content: space-between;
                    .left {
                        p {
                            font-size: 12px;
                            margin-left: 10px;
                        }
                        ::v-deep(.el-avatar--small) {
                            line-height: 25px;
                        }
                    }
                    .right {}
                    .repplycon {
                        margin-top: 15px;
                        p {
                            margin: 7px 0;
                            font-size: 12px;
                        }
                    }
                }
                .gtbox {
                    padding: 15px;
                    border:rgba(215, 215, 215, 1) 1px solid;
                    width: 520px;
                    margin-left: 150px;
                    justify-content: flex-start;
                    min-height: 150px;
                    .celltop {
                        margin-bottom: 15px;
                        span {
                            font-size: 12px;
                            color: #333;
                            text-align: left;
                        }
                        span.grayw {
                            color: #999;
                            width: 37px;
                        }
                        ::v-deep(.el-avatar--small) {
                            width: 28px;
                            color: #fff;
                            text-align: center;
                        }
                    }
                    .cellcon {
                        p {
                            font-size: 12px;
                            margin-bottom: 10px;
                        }
                    }
                }
            }
            .btns {
                margin-top: 60px;
                padding: 0 0 40px 100px;
                ::v-deep(.el-button) {
                    width: 100px;
                    height: 35px;
                    margin: 0 25px;
                }
            }
        }
    }
    .fjimg {
        width: 90px;
        height: 90px;
        margin: 0 8px;
    }
    .fjname {
        font-size: 12px;
        color: rgb(4, 41, 250);
        text-align: left;
        width: 300px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
</style>